// strings.js

const strings = {
    STRIPE_DEV_PRODUCT_PAYMENT_URL: "https://buy.stripe.com/test_3cseVX7tb8BH2ac15d", // dv
    STRIPE_PROD_PRODUCT_PAYMENT_URL: "https://buy.stripe.com/6oEcNF7Vs6Jo8QUbJR", // dv

    STRIPE_SUBSCRIPTION_MANAGEMENT_URL: "https://billing.stripe.com/p/login/28ocP200L31J9gs7ss",
    SUBSCRIPTION_STATUS_API_URL: "https://funquiz.app/modular2/subscription-status",
    
    GENERIC_PAGE_TITLE: "Da Vinci Gen AI 🎨",
    HOME_PAGE_TITLE: "Home - Da Vinci Gen AI 🎨",
    DASHBOARD_PAGE_TITLE: "Home - Da Vinci Gen AI 🎨",
    WELCOME_MESSAGE_H1_TITLE: "Welcome to Da Vinci Gen AI 🎨",
    FX_DESCRIPTION_MESSAGE: "This f(x) can be used to generate Da Vinci style images, choose an image and then press the 'Submit Input' button below to get your result!",
    
    MAIN_API_NAME: "davinci_gen_ai_1",
    MAIN_API_URL: "https://funquiz.app/modular2/davinci-gen-ai-1",

    PROD_CLERK_PUB_KEY: "pk_live_Y2xlcmsueW9sbGVnLmNvbSQ",
    DEV_CLERK_PUB_KEY: "pk_test_aGFybWxlc3MtYmVlLTY5LmNsZXJrLmFjY291bnRzLmRldiQ",

    // ... add more strings as needed
};



export default strings;